/** InventoryModuleRoute — pass-through; InventoryModule owns its masthead. */
import InventoryModule from "./InventoryModule";

export default function InventoryModuleRoute() {
  return <InventoryModule />;
}
